import { computed, type ComputedRef } from 'vue';
import { useDeviceStore } from '@/store/entities/deviceStore';
import { submeteringDeviceTypes } from '@/enums/device';
import { useDmgw6Store } from '@/store/dmgw6/dmgw6Store';
import useStores from '@/composables/useStores';
import type { Room } from '@/models';

export function useDmgw6RoomGroupFunkcheck(
  roomsOfRoomgroup: ComputedRef<Room[]>
) {
  const deviceStore = useDeviceStore();
  const { orderStore } = useStores();

  const dmgw6FunkcheckDevices = computed(() => {
    const devices: Array<{ id: string; serialNumber: string }> = [];
    for (const room of roomsOfRoomgroup.value) {
      deviceStore
        .getAllDevicesInRoom(room.id)
        .filter(
          (d) =>
            submeteringDeviceTypes.includes(d.deviceType) &&
            d.serialNumber &&
            d.isAutomatedMeterReading
        )
        .forEach((d) =>
          devices.push({ id: d.id, serialNumber: d.serialNumber })
        );
    }
    return devices;
  });

  const buildingDmgw6 = computed(() =>
    useDeviceStore().getDirectMeterGateway()
  );

  const showFunkcheckButton = computed(
    () =>
      !!buildingDmgw6.value &&
      (orderStore.activeOrder?.hasDmgw6Article() ?? false)
  );

  const allDmgw6DevicesHaveStatus = computed(() => {
    if (!showFunkcheckButton.value) return true;
    if (dmgw6FunkcheckDevices.value.length === 0) return true;
    const statuses = useDmgw6Store().deviceFunkcheckStatuses;
    return dmgw6FunkcheckDevices.value.every((d) => statuses.has(d.id));
  });

  return {
    allDmgw6DevicesHaveStatus,
  };
}
